export default __webpack_public_path__ + "static/update0002-2444d9adaf6b525cf7c501e65ccf3e30.png";